
import {FC} from "react";

import React from 'react';

import ApprovalToImplementForm from "../../forms/claim-handling-forms/approval-to-implement-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const ApprovalToImplementScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <ApprovalToImplementForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default ApprovalToImplementScreen;
